// Ardor Flag Designer: app layout. Ardor Printing.
// New Oct 11, 2026. Made from a copy of ardor-yardsign-app.js (unchanged) by the patch list core/app.patch. Turns the flag
// designer into a one-screen editor (tool rail, big stage, options panel with the total and Add to cart at the bottom,
// 2D/3D switch, 3D thumbnail, floating toolbar, 2D zoom bar). It only moves existing builder elements, so prices, proof,
// cart and quote work as before. Loaded by sections/ardor-flag-builder-ws.liquid after ardor-flag-builder.js.
(function () {
'use strict';
var root = document.querySelector('[data-abb-root]');
if (!root || root.__abx) return;

var $ = function (s, el) { return (el || root).querySelector(s); };
var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
var KEYS = ['shape', 'size', 'sides', 'art', 'kit', 'bag', 'qty', 'delivery'];
var step = {}, missing = false;
KEYS.forEach(function (k) { step[k] = $('.abb-step[data-abb-step="' + k + '"]'); if (!step[k]) missing = true; });
var wrap = $('.abb-wrap'), grid = $('.abb-grid'), head = $('.abb-head'), crumbs = $('.abb-crumbs');
var viewer = $('[data-abb-viewer]'), frame = $('.abb-layout__frame'), priceBox = $('.abb-price');
if (!wrap || !grid || !viewer || !frame || !priceBox || missing) return; // keep the normal layout
root.__abx = true;
root.classList.add('abb--app');

var P = 'fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"';
function svg(d, s) { return '<svg viewBox="0 0 24 24" width="' + (s || 22) + '" height="' + (s || 22) + '" ' + P + ' aria-hidden="true" focusable="false">' + d + '</svg>'; }
var I = {
art: '<path d="M12 15V4M7.5 8.5 12 4l4.5 4.5"/><path d="M4 15v3.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V15"/>',
design: '<path d="M12 3l1.8 4.6L18.5 9l-4.7 1.4L12 15l-1.8-4.6L5.5 9l4.7-1.4z"/><path d="M18.5 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/>',
quote: '<path d="M4 5h16v11H9l-5 4z"/><path d="M8 9.5h8M8 12.5h5"/>',
cube: '<path d="M12 2.8l8 4.5v9.4l-8 4.5-8-4.5V7.3z"/><path d="M12 21.2v-9.4M20 7.3l-8 4.5-8-4.5"/>',
flat: '<rect x="6" y="3" width="12" height="18" rx="1.5"/><path d="M9.5 8h5M9.5 11.5h5"/>',
x: '<path d="M6 6l12 12M18 6 6 18"/>',
up: '<path d="M12 15V4M7.5 8.5 12 4l4.5 4.5"/><path d="M4 15v3.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V15"/>',
chev: '<path d="M9 6l6 6-6 6"/>'
};
function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
function move(node, to, before) { if (node && to) to.insertBefore(node, before || null); return node; }
function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

// ---------- build the app shell ----------
var app = el('div', 'abx');
app.innerHTML =
'<nav class="abx-rail" aria-label="Flag tools">' +
'<button type="button" class="abx-tool" data-abx-fly="art">' + svg(I.art) + '<span>Artwork</span></button>' +

'<button type="button" class="abx-tool" data-abx-quote>' + svg(I.quote) + '<span>Quote</span></button>' +
'</nav>' +
'<section class="abx-stage" data-abx-stage aria-label="Your flag">' +
'<div class="abx-2d" data-abx-2d>' +
'<div class="abx-empty" data-abx-empty><div class="abx-empty__card">' +
'<span class="abx-empty__icon">' + svg(I.up, 22) + '</span>' +
'<h3 class="abx-empty__title">Drop your flag art here</h3>' +
'<p class="abx-empty__text">JPG, PNG, PDF, AI, EPS, TIFF or PSD, up to 25 MB. You\'ll see it on your flag right away.</p>' +
    '<div class="abx-empty__btns"><button type="button" class="abx-btn abx-btn--yellow" data-abx-upload>Upload artwork</button></div>' +
    '</div></div>' +
    '</div>' +
'<div class="abx-3d" data-abx-3d><button type="button" class="abx-hit" data-abx-hit aria-label="Open the 3D preview"></button><span class="abx-badge">' + svg(I.cube, 13) + '3D</span></div>' +
'<div class="abx-mode" role="group" aria-label="Preview">' +
'<button type="button" data-abx-mode="2d">' + svg(I.flat, 16) + '2D</button>' +
'<button type="button" data-abx-mode="3d">' + svg(I.cube, 16) + '3D</button>' +
'</div>' +
'<p class="abx-hint" data-abx-hint></p>' +
'<div class="abx-bar" data-abx-bar><button type="button" class="abx-tbtn" data-abx-upload>' + svg(I.up, 17) + '<span data-abx-upload-label>Upload</span></button></div>' +
'</section>' +
'<aside class="abx-panel" aria-label="Flag options">' +
'<div class="abx-panel__head"><h2 class="abx-panel__title">Custom Flags</h2><p class="abx-panel__sub" data-abx-sub></p></div>' +
'<div class="abx-panel__body" data-abx-body></div>' +
'<div class="abx-foot" data-abx-foot>' +
'<div class="abx-foot__row"><span class="abx-foot__label">Total</span></div>' +
'<div class="abx-foot__btns"></div>' +
'</div>' +
'</aside>' +
'<div class="abx-fly" data-abx-flyout hidden role="dialog" aria-label="Artwork">' +
'<div class="abx-fly__head"><h2 data-abx-fly-title>Artwork</h2><button type="button" class="abx-x" data-abx-fly-close aria-label="Close">' + svg(I.x, 20) + '</button></div>' +
'<div class="abx-fly__body" data-abx-fly-body></div>' +
'</div>';

var stage = $('[data-abx-stage]', app), box2d = $('[data-abx-2d]', app), box3d = $('[data-abx-3d]', app);
var body = $('[data-abx-body]', app), foot = $('[data-abx-foot]', app), bar = $('[data-abx-bar]', app);
var fly = $('[data-abx-flyout]', app), flyBody = $('[data-abx-fly-body]', app);
var empty = $('[data-abx-empty]', app), hint = $('[data-abx-hint]', app), sub = $('[data-abx-sub]', app);

// stage: 2D layout canvas and the 3D viewer
move(frame, box2d, empty);
  move($('[data-abb-z2d]'), box2d); // 2D zoom bar for tall flags
move(viewer, box3d, box3d.firstChild);

// 2D toolbar: front/back tabs, art size and placement, upload or replace
var tabs = $('[data-abb-art-tabs]'), ctl = $('[data-abb-layout-controls]');
move(tabs, bar, bar.firstChild);
move(ctl, bar, bar.lastChild);

  // options panel: shape, size, sides, pole kit, carry bag, quantity, notes and delivery
  var PANEL = ['shape', 'size', 'sides', 'kit', 'bag', 'qty', 'delivery'];
  PANEL.forEach(function (k) { move(step[k], body); });
var rush = $('.abb-price__rush', priceBox); if (rush) move(rush, body);

// footer: alerts, total, Add to cart and quote
var fRow = $('.abx-foot__row', foot), fBtns = $('.abx-foot__btns', foot);
move($('[data-abb-warn]', priceBox), foot, fRow);
move($('[data-abb-error]', priceBox), foot, fRow);
move($('[data-abb-total]', priceBox), fRow);
move($('[data-abb-each]', priceBox), foot, fBtns);
move($('.abb-price__free', priceBox), foot, fBtns);
var quoteBtn = $('[data-abb-quote]', priceBox), addBtn = $('[data-abb-add]', priceBox);
if (quoteBtn) {
quoteBtn.className = 'abx-icon-btn';
quoteBtn.setAttribute('aria-label', 'Request a quote'); quoteBtn.title = 'Request a quote';
quoteBtn.innerHTML = svg(I.quote, 22);
move(quoteBtn, fBtns);
}
move(addBtn, fBtns);

// artwork flyout: upload (this builder has no design service, so design and designCard stay empty)
move(step.art, flyBody);
var design = $('[data-abb-design]', step.art), designCard = design && design.closest('label'); // scoped to the step: the app shell is not in the page yet

// page text goes under the builder, like the banner and sticker builder pages
var below = el('div', 'abx-below');
if (crumbs) move(crumbs, below);
if (head) move(head, below);
move($('.abb-stage-note'), below);
wrap.insertBefore(app, grid);
wrap.insertBefore(below, grid);

// ---------- state ----------
var state = { mode: '2d', fly: '' };
var openRow = null;
function fireResize() { try { window.dispatchEvent(new Event('resize')); } catch (e) {} }
function apply() {
app.setAttribute('data-mode', state.mode);
box2d.className = 'abx-2d ' + (state.mode === '2d' ? 'is-full' : 'is-off');
box3d.className = 'abx-3d ' + (state.mode === '3d' ? 'is-full' : 'is-thumb');
$('[data-abx-hit]', app).hidden = state.mode === '3d';
$$('[data-abx-mode]', app).forEach(function (b) { var on = b.getAttribute('data-abx-mode') === state.mode; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
fly.hidden = !state.fly;
app.setAttribute('data-fly', state.fly ? '1' : '0');
$$('.abx-rail [data-abx-fly]', app).forEach(function (b) { var on = b.getAttribute('data-abx-fly') === state.fly; b.classList.toggle('is-on', on); b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
$('[data-abx-fly-title]', app).textContent = state.fly === 'design' ? 'Design help' : 'Artwork';
if (designCard) designCard.classList.toggle('abx-glow', state.fly === 'design');
fitThumb(true);
fireResize();
}
function setMode(m) { state.mode = m; apply(); }
function reveal(n) { var b = n && n.closest('.abx-panel__body, .abx-fly__body'); if (!b) return; var r = n.getBoundingClientRect(), br = b.getBoundingClientRect(); if (r.bottom > br.bottom) b.scrollTop += r.bottom - br.bottom + 8; else if (r.top < br.top) b.scrollTop -= br.top - r.top + 8; }
function openFly(which, focusEl) {
state.fly = which; apply();
var t = focusEl || (which === 'design' ? designCard : null);
if (t) setTimeout(function () { reveal(t); }, 40);
}
function closeFly() { if (!state.fly) return; state.fly = ''; apply(); }

app.addEventListener('click', function (e) {
var t = e.target.closest('button'); if (!t || !app.contains(t)) return;
if (t.hasAttribute('data-abx-mode')) { setMode(t.getAttribute('data-abx-mode')); return; }
if (t.hasAttribute('data-abx-hit')) { setMode('3d'); return; }
if (t.hasAttribute('data-abx-fly')) {
var w = t.getAttribute('data-abx-fly');
if (state.fly === w && t.closest('.abx-rail')) { closeFly(); return; }
if (w === 'design' && t.closest('.abx-empty') && design && !design.checked) design.click();
openFly(w); return;
}
if (t.hasAttribute('data-abx-fly-close')) { closeFly(); return; }
if (t.hasAttribute('data-abx-upload')) { var inp = $('[data-abb-file]'); if (inp) inp.click(); return; }
if (t.hasAttribute('data-abx-quote')) { if (quoteBtn) quoteBtn.click(); return; }
});
document.addEventListener('keydown', function (e) {
if (e.key !== 'Escape' || document.querySelector('dialog[open]')) return;
if (state.fly) closeFly(); else if (openRow) toggleRow(openRow, false);
});

// ---------- compact option rows: one tight row per option, long lists open under their row ----------
var rowsEl = el('div', 'abx-rows');
body.insertBefore(rowsEl, body.firstChild);
PANEL.forEach(function (k) { step[k].classList.add('abx-gone'); });
function txt(n) { return n ? n.textContent.replace(/\s+/g, ' ').trim() : ''; }
function pressed(c) { return c ? $('.abb-opt[aria-pressed="true"]', c) : null; }
function row(key, label, cls) {
var r = el('div', 'abx-row' + (cls ? ' ' + cls : ''), '<span class="abx-row__label">' + label + '</span>');
r.setAttribute('data-abx-row', key);
rowsEl.appendChild(r);
return r;
}
function toggleRow(r, force) {
var open = force == null ? r._drop.hidden : force;
if (open && openRow && openRow !== r) toggleRow(openRow, false);
r._drop.hidden = !open;
r._btn.setAttribute('aria-expanded', open ? 'true' : 'false');
r.classList.toggle('is-open', open);
if (open) { openRow = r; setTimeout(function () { reveal(r); }, 0); }
else if (openRow === r) openRow = null;
}
function picker(key, label, parts, summary, keepOpen) {
var r = row(key, label, 'abx-row--pick');
var btn = el('button', 'abx-pick'); btn.type = 'button'; btn.setAttribute('aria-expanded', 'false');
var drop = el('div', 'abx-drop'); drop.hidden = true;
r.appendChild(btn); r.appendChild(drop);
r._btn = btn; r._drop = drop;
parts.forEach(function (p) { if (p) drop.appendChild(p); });
var last = null;
var sync = r._sync = function () { var h = summary(); if (h === last) return; last = h; btn.innerHTML = '<span class="abx-pick__val">' + h + '</span>' + svg(I.chev, 16); };
btn.addEventListener('click', function () { toggleRow(r); });
drop.addEventListener('click', function (e) { var b = e.target.closest('.abb-opt'); if (b && !keepOpen(b)) setTimeout(function () { toggleRow(r, false); }, 0); });
parts.forEach(function (p) { if (p) new MutationObserver(sync).observe(p, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-pressed', 'hidden', 'disabled'] }); });
sync();
return r;
}
function bindHidden(r, src) {
if (!src) return;
var f = function () { r.hidden = !!src.hidden; if (r.hidden && openRow === r) toggleRow(r, false); };
new MutationObserver(f).observe(src, { attributes: true, attributeFilter: ['hidden'] });
f();
}
// a note under a row: shown only while it has text
function note(r, n) {
if (!n) return;
move(n, r);
var quiet = function () { n.classList.toggle('abx-quiet', !txt(n)); };
new MutationObserver(quiet).observe(n, { childList: true, characterData: true, subtree: true });
quiet();
}

  // flag shape: one row with the chosen shape and its "from" price; the shapes open under it
  var shapes = $('[data-abb-shapes]');
  picker('shape', 'Flag', [shapes], function () {
    var on = pressed(shapes);
    if (!on) return '<strong>Choose a flag</strong>';
    return '<strong>' + esc(txt($('.abb-opt__name', on)) || txt(on)) + '</strong><em>' + esc(txt($('.abb-opt__price', on))) + '</em>';
  }, function () { return false; });

  // size: one row with the chosen size and its price; the sizes of that shape open under it
  var sizes = $('[data-abb-sizes]');
  picker('size', 'Size', [sizes], function () {
    var on = pressed(sizes);
    if (!on) return '<strong>Choose a size</strong>';
    return '<strong>' + esc(txt($('.abb-opt__name', on)) || txt(on)) + '</strong><em>' + esc(txt($('.abb-opt__price', on))) + '</em>';
  }, function () { return false; });

  // sides: a two-button switch; 1 side shows the pole side, 2 sides the choice for the back (same art or its own)
  var rSides = row('sides', 'Sides');
  move($('[data-abb-sides]'), rSides);
  note(rSides, $('[data-abb-sides-note]'));
  move($('[data-abb-pole-wrap]'), rSides);
  move($('[data-abb-backmode-wrap]'), rSides);

  // pole and base: one row with the chosen kit and the price per flag; the kits open under it
  var kits = $('[data-abb-kits]');
  var rKit = picker('kit', 'Pole & base', [kits], function () {
    var on = pressed(kits);
    if (!on) return '<strong>Choose a pole kit</strong>';
    return '<strong>' + esc(txt($('.abb-opt__name', on)) || txt(on)) + '</strong><em>' + esc(txt($('.abb-opt__price', on))) + '</em>';
  }, function () { return false; });
  note(rKit, $('[data-abb-kit-note]'));

  // carry bag: no or yes, only when the flag has a bag
  var rBag = row('bag', 'Carry bag');
  move($('[data-abb-bags]'), rBag);
  note(rBag, $('[data-abb-bag-note]'));
  bindHidden(rBag, $('[data-abb-bag-wrap]') || step.bag);

  // quantity: 1 to 100 flags, more is a quote
  var rQty = row('qty', 'Quantity', 'abx-row--stack');
  move($('[data-abb-qty-box]'), rQty);
  note(rQty, $('[data-abb-qty-note]'));
  move($('[data-abb-quote-note]'), rQty);

  // notes, then delivery: free shipping or free pickup in Snohomish
  var rNotes = row('notes', 'Notes', 'abx-row--stack');
  move($('[data-abb-notes-field]'), rNotes);
  var rDel = row('delivery', 'Delivery', 'abx-row--stack');
  move($('[data-abb-delivery]'), rDel);

// ---------- live labels ----------
  var chips = ['[data-abb-chip-size]', '[data-abb-chip-mat]', '[data-abb-chip-sides]'].map(function (s) { return $(s); });
  var tip = $('[data-abb-tip]'); // the builder writes the tip for the stage here
  function syncSub() {
    var t = chips.map(function (c) { return c ? txt(c) : ''; }).filter(Boolean);
    sub.textContent = t.join(' · ');
    var size = chips[0] ? txt(chips[0]) : '';
    hint.textContent = (size ? size + ' · ' : '') + ((tip && txt(tip)) || 'Keep text inside the red line');
    fitThumb();
  }
  chips.concat([tip]).forEach(function (c) { if (c) new MutationObserver(syncSub).observe(c, { childList: true, characterData: true, subtree: true }); });

  // ---------- keep the sign out from under the 3D thumbnail ----------
  // The layout drawing is centered on the stage. When it would run under the thumbnail (top right), it either moves
  // left of the thumbnail (.abx-tight) or down below it (.abx-under), whichever leaves it bigger (see ardor-yardsign-ws.css).
var layCanvas = $('canvas', frame);
  // the flag's page shape (width / height), from the designer itself
  function signRatio() {
    try { var c = window.ArdorFlagAPI && window.ArdorFlagAPI.cfg(); if (c && c.Wi > 0 && c.Hi > 0) return c.Wi / c.Hi; } catch (e) {}
    if (layCanvas && layCanvas.style.width && layCanvas.width > 0 && layCanvas.height > 0) return layCanvas.width / layCanvas.height;
    return 1 / 4;
  }
  function fitThumb(quiet) {
    var sw = stage.clientWidth, sh = stage.clientHeight;
    if (!sw || !sh) return;
    var had = app.classList.contains('abx-tight') ? 'tight' : (app.classList.contains('abx-under') ? 'under' : '');
    var want = '';
    if (state.mode === '2d') {
      app.classList.remove('abx-tight', 'abx-under'); // measure the plain paddings
      var cs = window.getComputedStyle(frame);
      var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0, pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0;
      var tw = box3d.offsetWidth || 160, th = box3d.offsetHeight || 120, r = signRatio();
      var fitW = function (w, h) { return Math.max(0, Math.min(w, h * r)); };
      var w0 = fitW(sw - pl - pr, sh - pt - pb), h0 = w0 / r;
      var thumbLeft = box3d.offsetLeft > 0 ? box3d.offsetLeft : sw - tw - 16, thumbBottom = (box3d.offsetTop > 0 ? box3d.offsetTop : 16) + th;
      var top0 = pt + (sh - pt - pb - h0) / 2;
      if ((sw + w0) / 2 + 8 > thumbLeft && top0 < thumbBottom + 8) {
        var wTight = fitW(sw - 16 - (tw + 32), sh - pt - pb);
        var wUnder = fitW(sw - pl - pr, sh - (thumbBottom + 12) - pb);
        want = wUnder >= wTight ? 'under' : 'tight';
      }
    }
    app.classList.toggle('abx-tight', want === 'tight');
    app.classList.toggle('abx-under', want === 'under');
    if (want !== had && !quiet) fireResize();
  }
if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { fitThumb(); }).observe(stage); } catch (e) {} }
else window.addEventListener('resize', function () { fitThumb(true); });

// ---------- empty canvas card ----------
var fileName = $('[data-abb-file-name]'), backSame = $('[data-abb-back-same]');
var upLabel = $('[data-abx-upload-label]', app);
function syncEmpty() {
var hasArt = fileName && !fileName.hidden;
var onBack = tabs && !tabs.hidden && $('[data-abb-face="back"][aria-pressed="true"]', tabs);
var same = onBack && !!$('[data-backmode="same"][aria-pressed="true"]'); // the back shows the front art
    var eTitle = $('.abx-empty__title', app); if (eTitle) eTitle.textContent = onBack ? 'Drop the art for the back here' : 'Drop your flag art here';
var noArt = !hasArt && !(design && design.checked) && !same;
empty.hidden = !noArt;
app.classList.toggle('abx-has-art', !!hasArt);
if (upLabel) upLabel.textContent = hasArt ? 'Replace art' : 'Upload';
}
if (fileName) new MutationObserver(syncEmpty).observe(fileName, { attributes: true, attributeFilter: ['hidden'] });
if (tabs) new MutationObserver(syncEmpty).observe(tabs, { attributes: true, subtree: true, attributeFilter: ['hidden', 'aria-pressed'] });
root.addEventListener('change', function () { setTimeout(syncEmpty, 0); });
  var bmEl = $('[data-abb-backmodes]');
  if (bmEl) new MutationObserver(function () { setTimeout(syncEmpty, 0); }).observe(bmEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });

// ---------- drop a file anywhere on the canvas ----------
function hasFiles(e) { try { return Array.prototype.indexOf.call(e.dataTransfer.types, 'Files') >= 0; } catch (er) { return false; } }
stage.addEventListener('dragover', function (e) { if (!hasFiles(e)) return; e.preventDefault(); stage.classList.add('is-over'); });
stage.addEventListener('dragleave', function (e) { if (!stage.contains(e.relatedTarget)) stage.classList.remove('is-over'); });
stage.addEventListener('drop', function (e) {
if (!hasFiles(e)) return;
e.preventDefault(); stage.classList.remove('is-over');
var inp = $('[data-abb-file]'), f = e.dataTransfer.files && e.dataTransfer.files[0];
if (!inp || !f) return;
try { var dt = new DataTransfer(); dt.items.add(f); inp.files = dt.files; } catch (er) { return; }
inp.dispatchEvent(new Event('change', { bubbles: true }));
});

// ---------- point customers to whatever needs fixing ----------
var errEl = $('[data-abb-error]');
if (errEl) new MutationObserver(function () {
if (errEl.hidden) return;
var t = errEl.textContent;
if (/^upload /i.test(t)) openFly('art', $('[data-abb-drop]'));
else closeFly();
}).observe(errEl, { attributes: true, attributeFilter: ['hidden'], childList: true, characterData: true, subtree: true });

syncEmpty();
apply();
syncSub();
})();
